import React, { Component } from 'react';
import { connect } from "react-redux";

class Step extends Component {
    getClassName(i) {
        let currentStep = Math.floor(this.props.currentStep / 2) % 16;
        let className = "";

        if (this.props.stepNumber === currentStep) {
            className = "current-step step";
        } else if (this.props.stepNumber < currentStep) {
            className = "previous-step step";
        } else {
            className = "step";
        }

        if (this.props.toggled && this.props.stepNumber !== currentStep) {
            className += ' toggled';
        }
        if (this.props.rollingStepNumber !== undefined) {
            let rollStep = Math.floor(this.props.rollingStepNumber / 2) % 16;
            if (rollStep === this.props.stepNumber) {
                className += " rolling-step";
            }
        }
        return className;
    }

    isCurrent() {
        let currentStep = Math.floor(this.props.currentStep / 2) % 16;

        if (this.props.toggled && this.props.stepNumber === currentStep) {
            return true;
        }
        return false;
    }

    render() {
        let className = this.getClassName();
        let style = {
        };
        if (this.isCurrent()) { 
            let triggers = 0;
            for (let track of this.props.sequencerEngine.tracks) {
                if (!track.isFrozen) {
                    triggers += (track.triggerCount || 0) + (track.otherTriggerCount || 0);
                }
            }
            if (triggers > 0) {
                triggers = Math.pow(triggers, 1.3);
                style.boxShadow = `0px 0px ${triggers}px ${triggers}px #ff5151`
            }
        }
        return (
            <div
              style={style}
              onMouseOver={this.props.onMouseOver}
              onMouseDown={this.props.onMouseDown}
              className={className}>
            </div>
        );
    }
}


const mapStateToProps = (state, props) => {
    return {
        toggled: state.steps.masterStepToggles[props.stepNumber]
    };
};


export default connect(mapStateToProps, null)(Step);


